module.exports = __webpack_public_path__ + "img/08.22.42.fa8c2dd0.jpg";